var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _initialiseProps;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import t from 'prop-types';
import BotoneraIndice from './botonera-indice';
import CabeceraIndice from './cabecera-indice';
import ComponenteContenedores from './contenedores'; // import ContenedorIndice from './contenedor-indice'

import { decodificarZonaId, sessionStorage } from '../util';
var sessionStorageKey = 'pantalla-indice';
var Indice = (_temp = _class = function (_React$Component) {
  _inherits(Indice, _React$Component);

  function Indice(props) {
    var _indexUnidad;

    _classCallCheck(this, Indice);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var lastState = JSON.parse(sessionStorage.getItem(sessionStorageKey) || "{}");
    _this.state = {
      indexUnidad: (_indexUnidad = {}, _indexUnidad[props.libroId] = props.configIndice.unidadInicio ? props.configIndice.unidadInicio : 0, _indexUnidad)
    };

    if (lastState.indexUnidad) {
      _this.state.indexUnidad = _extends({}, _this.state.indexUnidad, lastState.indexUnidad);
    }

    return _this;
  }

  Indice.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _props = this.props,
        libroId = _props.libroId,
        configIndice = _props.configIndice;

    if (prevProps.libroId !== libroId) {
      var _extends2;

      var indexUnidad = this.state.indexUnidad;
      var newState = {
        indexUnidad: _extends({}, indexUnidad, (_extends2 = {}, _extends2[libroId] = indexUnidad[libroId] || (configIndice.unidadInicio ? configIndice.unidadInicio : 0), _extends2))
      };
      this.setState(newState);
    }
  };

  Indice.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stateToLocalStorage();
  };

  Indice.prototype.render = function render() {
    var indexUnidad = this.state.indexUnidad;
    var _props2 = this.props,
        libroId = _props2.libroId,
        configIndice = _props2.configIndice,
        onAtras = _props2.onAtras;
    var contenedores = configIndice.contenedores;

    if (!contenedores) {
      var tituloContenedor = configIndice.tituloContenedor,
          unidades = configIndice.unidades,
          extrasContenedor = configIndice.extrasContenedor;
      contenedores = [{
        titulo: tituloContenedor,
        contenedoresUnidades: [{
          unidades: [].concat(unidades)
        }],
        extrasContenedor: [].concat(extrasContenedor || [])
      }];
    }

    var Contenedores = this.props.Contenedores || ComponenteContenedores;
    return React.createElement('div', {
      className: 'fondoMenus'
    }, React.createElement('div', {
      className: "indice indice" + libroId
    }, configIndice.adornos && configIndice.adornos.map(function (num) {
      return React.createElement('img', {
        key: 'adorno-' + num,
        className: 'adorno' + num,
        src: 'css/imagenes/menus/adorno' + num + '.png',
        alt: ''
      });
    }), React.createElement(CabeceraIndice, {
      libroId: libroId,
      configIndice: configIndice,
      onEntrada: this.handleEntrada,
      onAtras: onAtras
    }), React.createElement(Contenedores, {
      contenedores: contenedores,
      indexUnidad: indexUnidad,
      libroId: libroId,
      onEntrada: this.handleEntrada
    }), configIndice.botoneraIndice && React.createElement(BotoneraIndice, {
      libroId: libroId,
      botoneraIndice: configIndice.botoneraIndice,
      onEntrada: this.handleEntrada
    })));
  };

  return Indice;
}(React.Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.stateToLocalStorage = function () {
    sessionStorage.setItem(sessionStorageKey, JSON.stringify(_this2.state));
  };

  this.handleEntrada = function (entrada, index) {
    var indexUnidad = _this2.state.indexUnidad;
    var _props3 = _this2.props,
        libroId = _props3.libroId,
        onPagina = _props3.onPagina,
        onZona = _props3.onZona,
        onIndice = _props3.onIndice,
        onPantalla = _props3.onPantalla,
        onAtras = _props3.onAtras;

    if (entrada.zona) {
      var _decodificarZonaId = decodificarZonaId(entrada.zona),
          libroIdZona = _decodificarZonaId.libroId,
          numPagina = _decodificarZonaId.numPagina,
          numZona = _decodificarZonaId.numZona;

      onZona(libroIdZona, numPagina, numZona);
    } else if (entrada.pagina) {
      if (typeof entrada.pagina === 'string') {
        var _entrada$pagina$split = entrada.pagina.split(','),
            libroIdAlternativo = _entrada$pagina$split[0],
            pagina = _entrada$pagina$split[1];

        onPagina(libroIdAlternativo, Number(pagina));
      } else {
        onPagina(libroId, entrada.pagina);
      }
    } else if (entrada.lecciones) {
      var _extends3;

      var newIndexUnidad = _extends({}, indexUnidad, (_extends3 = {}, _extends3[libroId] = index, _extends3));

      _this2.setState({
        indexUnidad: newIndexUnidad
      }, _this2.stateToLocalStorage);
    } else if (entrada.indice) {
      onIndice(entrada.indice);
    } else if (entrada.pantalla) {
      var _entrada$pantalla = entrada.pantalla,
          pantallaId = _entrada$pantalla.pantallaId,
          props = _entrada$pantalla.props;
      onPantalla(pantallaId, props || {});
    } else if (entrada.atras) {
      onAtras();
    }
  };
}, _temp);
Indice.propTypes = process.env.NODE_ENV !== "production" ? {
  libroId: t.string.isRequired,
  // libroId del indice de esta pantalla
  configIndice: t.shape({
    adornos: t.arrayOf(t.string),
    // Ejemplo: ["3"] para poner el adorno3
    titulo: t.string,
    // Titulo de la pantalla de indice
    fondoCabecera: t.string,
    // ruta completa de la imagen de fondo de la cabecera
    nivel: t.string,
    // Texto para número de nivel
    tituloContenedor: t.string,
    // titulo del contenedor
    unidadInicio: t.number,
    // unidad 'desplegada' al inicio
    // contenido
    // o bien tiene 'unidades' => un solo contenedorIndice con un solo contenedorUnidades
    // o bien tiene 'contenedores' con la gerarquia completa
    unidades: t.array,
    // array de unidades
    contenedores: t.arrayOf(t.shape({
      titulo: t.string,
      contenedoresUnidades: t.arrayOf(t.shape({
        titulo: t.string,
        unidades: t.array.isRequired
      })).isRequired
    })),
    botoneraIndice: t.oneOfType([t.arrayOf(t.string), t.arrayOf(t.arrayOf(t.shape({
      indice: t.string
    })))]),
    // array de libroIds, que pueden a su vez estar agrupados
    textoAtras: t.string // Puede contener html

  }).isRequired,
  ExtrasBotonera: t.any,
  // Elementos extra de la botonera (jsx), recibiran como props: libroId, configIndice, onIndice, onAtras y onEntrada

  /** 
   * Componente ContenedorContenedores en caso de que no se quiera utilizar
   * el Componente por defecto "Contenedores"
   */
  Contenedores: t.any,
  // acciones
  onPagina: t.func.isRequired,
  onZona: t.func.isRequired,
  onIndice: t.func.isRequired,
  onAtras: t.func.isRequired,
  onPantalla: t.func.isRequired
} : {};
export default Indice;